<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container">
        <v-layout class="d-flex justify-end mb-3">
            <v-btn color="primary" @click="exportarExcel">
                <v-icon left size="18">
                    mdi-file-chart
                </v-icon>
                SALVAR RELATÓRIO
            </v-btn>
        </v-layout>
        <m-form ref="form" class="pt-4" @submit.prevent="enviar()">
            <div class="tooltip-icon icon-container position-relative"
                 style="width: 18px; height: 18px; position: relative; margin-top: -30px;">
                <v-icon style="margin-top:35px;" size="18" color="primary" @mouseleave="opacity_aviso_principal = 0"
                        @mouseenter="opacity_aviso_principal = 3">
                    mdi-help-box
                </v-icon>
                <div class="tooltip-descricao-perfil v-card transition"
                     :style="{ opacity: opacity_aviso_principal ? opacity_aviso_principal : 0, zIndex: opacity_aviso_principal ? '99' : '-2', marginTop: '20px' }">
                    <span style="color: #222222">Se a unidade de negócio do usuário retornada no Newcon está definida
                        como “exclusiva” em ao menos um ambiente, será exibido para o usuário apenas os ambientes onde a
                        sua unidade de negócio está definida como “exclusiva” desde que a empresa do ambiente também
                        esteja liberada para o usuário no Newcon.<br /><br />
                        <strong>Atenção:</strong> Se o usuário não tem acesso a nenhuma das empresas vinculadas aos
                        ambientes onde sua unidade de negócio está definida como exclusiva, o usuário não conseguirá
                        acessar o sistema via SSO v2.<br /><br />
                        Se a unidade de negócio do usuário não é exclusiva de nenhum dos ambientes cadastrados, será
                        exibido todos os ambientes vinculados às empresas liberadas para o usuário no Newcon desde que o
                        ambiente esteja definido como “ID visual padrão para a empresa liberada no Newcon.”<br /><br />
                        <strong>Atenção:</strong> Se a Unidade de Negócio do Usuário não é exclusiva em nenhum ambiente
                        e não existe nenhum ambiente marcado como ID visual padrão para empresa do usuário, não será
                        carregado nenhum ambiente para o usuário e o mesmo não conseguirá acessar o sistema via SSO
                        v2.</span>
                </div>
                <span class="icon-title">A validação de ambiente é utilizada na autenticação SSO v2 durante a integração
                    do ED com a Plataforma de Vendas Topaz.</span>
            </div>
            <br /><br />

            <DataTable :headers="headers" :params="params" :filter="dtFiltro" url="/painel/ambientes/listar"
                       overflow-y-visible style="padding:0px" id="DataTableAmbientes" ref="data_table_ambientes">
                <template v-slot:header="header">
                    <th v-for="(header, i) in headers" :key="i" style="height: 5px">
                        <div v-if="header.value === 'id_visual_padrao_para_empresas'"
                             class="tooltip-icon position-relative"
                             style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                            <v-icon size="18" color="primary" @mouseleave="opacity_visual_padrao = 0"
                                    @mouseenter="opacity_visual_padrao = 1">
                                mdi-help-box
                            </v-icon>
                            <div class="tooltip-descricao-visual_padrao v-card transition"
                                 :style="{ opacity: opacity_visual_padrao ? opacity_visual_padrao : 0, zIndex: opacity_visual_padrao ? '2' : '-2' }">
                                <span style="color: #222222;font-weight: 500;">{{ header.infoList[0] }}</span>
                            </div>
                        </div>
                        <div v-if="header.value === 'unidade_condicoes_venda'"
                             class="tooltip-icon position-relative"
                             style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                            <v-icon size="18" color="primary" @mouseleave=" opacity_unidade_condicoes = 0"
                                    @mouseenter=" opacity_unidade_condicoes = 1">
                                mdi-help-box
                            </v-icon>
                            <div class="tooltip-descricao-visual_padrao v-card transition"
                                 :style="{ opacity: opacity_unidade_condicoes ? opacity_unidade_condicoes : 0, zIndex: opacity_unidade_condicoes ? '2' : '-2' }">
                                <span style="color: #222222;font-weight: 500;">{{ header.infoList[0] }}</span>
                            </div>
                        </div>
                        <div v-if="header.value === 'unidades_negocio_exclusivas'"
                             class="tooltip-icon position-relative"
                             style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                            <v-icon size="18" color="primary" @mouseleave="opacidade_unidade_exclusiva = 0"
                                    @mouseenter="opacidade_unidade_exclusiva = 1">
                                mdi-help-box
                            </v-icon>
                            <div class="tooltip-descricao-visual_padrao v-card transition"
                                 :style="{ opacity: opacidade_unidade_exclusiva ? opacidade_unidade_exclusiva : 0, zIndex: opacidade_unidade_exclusiva ? '2' : '-2' }">
                                <span style="color: #222222;font-weight: 500;">{{ header.infoList[0] }} </span>
                                <strong style="color: #222222">“ID Visual Padrão para Empresa”.</strong>
                            </div>
                        </div>
                    </th>
                </template>
                <template v-slot:items="{item}" style="margin-top: -30px;">
                    <td v-if="item.id != 0">
                        {{ item.id }}
                    </td>
                    <td v-else-if="item.id == 0 && exibirItemNovo">
                    </td>

                    <td style="max-width:180px;" v-if="item.id != 0">
                        <v-select id="FieldSetIdentidadeVisual" outlined
                                  @change="($event) => dialogChangeIdentidadeVisual(item.id, $event, item.id_empresa_newcon, item.id_visual_padrao_para_empresas)"
                                  menu-props="offsetY" hide-details style="marginBottom:24px;maxWidth: 100%;padding:0px"
                                  :value="item.id_visual" :items="identidades_visuais" item-text="nome_amigavel"
                                  item-value="nome_amigavel" />
                    </td>
                    <td v-else-if="item.id == 0 && exibirItemNovo">
                        <v-select id="FieldSetIdentidadeVisual" outlined v-model="itemNovo.id_visual"
                                  menu-props="offsetY" hide-details placeholder="Selecione" :rules="[$rules.required]"
                                  style="marginBottom:24px;maxWidth: 100%;padding:0px" :value="item.id_visual"
                                  :items="identidades_visuais" item-text="nome_amigavel" item-value="nome_amigavel" />
                    </td>
                    <td class="apagaInput" v-if="item.id != 0">
                        <v-switch class="d-flex justify-center" style="margin-top:12px"
                                  @change="($event) => dialogChangeIdVisualPadraoTodasEmpresas(item.id, item.id_visual, item.id_empresa_newcon, $event)"
                                  v-model="item.id_visual_padrao_para_empresas"></v-switch>
                    </td>
                    <td v-else-if="item.id == 0 && exibirItemNovo">
                        <v-switch class="d-flex justify-center" style="margin-top:12px"
                                  v-model="itemNovo.idVisualPadraoParaEmpresas"></v-switch>
                    </td>
                    <td style="max-width:340px" v-if="item.id != 0">
                        <v-select outlined menu-props="offsetY" hide-details
                                  style="marginBottom:24px;maxWidth: 100%;padding:0px" :value="item.id_empresa_newcon"
                                  :items="empresas_newcon" item-text="nome_para_mostrar"
                                  @change="($event) => dialogChangeEmpresaNewcon(item.id, item.id_visual, $event, item.id_visual_padrao_para_empresas)"
                                  item-value="id_empresa_newcon" />
                    </td>
                    <td style="max-width:340px" v-else-if="item.id == 0 && exibirItemNovo">
                        <v-select outlined menu-props="offsetY" hide-details :rules="[$rules.required]"
                                  style="marginBottom:24px;maxWidth: 100%;padding:0px" v-model="itemNovo.id_empresa_newcon"
                                  :items="empresas_newcon" item-text="nome_para_mostrar" item-value="id_empresa_newcon" />
                    </td>
                    <td v-if="item.id != 0">
                        <v-text-field
                                v-model="item.unidade_condicoes_venda"
                                :value="item.unidade_condicoes_venda"
                                outlined
                                dense
                                hide-details
                                style="marginBottom:24px;maxWidth: 100%;padding:0px"
                                @change="dialogChangeUnidadeCondicoesVenda(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)"
                        ></v-text-field>
                    </td>
                    <td v-else-if="item.id == 0 && exibirItemNovo">
                        <v-text-field
                                v-model="itemNovo.unidadeCondicoesVenda"
                                outlined
                                dense
                                hide-details
                                style="marginBottom:24px;maxWidth: 100%;padding:0px"
                                @change="dialogChangeUnidadeCondicoesVenda(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)"
                        ></v-text-field>
                    </td>
                    <td style="padding:0px" v-if="item.id != 0">
                        <div class='d-flex' v-if="item.unidades_negocio_exclusivas != null">
                            <ComboBoxWithDelete :only-numbers="true" ref="comboBoxWithDelete"
                                                style="max-width:330px;padding:0px;margin-top:-20px;margin-bottom: -20px;margin-right: 5px; margin-left: 5px;"
                                                :id="item.id" :value="JSON.parse(`[${item.unidades_negocio_exclusivas}]`)"
                                                @data="dialogChangeUnidadeNegocio(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)"
                                                @delete="($event) => dialogDeleteUnidadeExclusiva(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)">
                            </ComboBoxWithDelete>

                            <v-icon size="36" color="primary"
                                    @click="() => { dialogExcluirAmbiente(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas) }">
                                mdi-trash-can-outline
                            </v-icon>
                        </div>
                        <div class='d-flex' v-else>
                            <ComboBoxWithDelete :only-numbers="true" ref="comboBoxWithDelete"
                                                style="max-width:330px;padding:0px;margin-top:-20px;margin-bottom: -20px;margin-right: 5px; margin-left: 5px;"
                                                :id="item.id"
                                                @data="dialogChangeUnidadeNegocio(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)"
                                                @delete="($event) => dialogDeleteUnidadeExclusiva(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas, $event)">
                            </ComboBoxWithDelete>

                            <v-icon size="36" color="primary"
                                    @click="() => { dialogExcluirAmbiente(item.id, item.id_visual, item.id_empresa_newcon, item.id_visual_padrao_para_empresas) }">
                                mdi-trash-can-outline
                            </v-icon>
                        </div>
                    </td>
                    <td style="padding:0px" v-if="item.id == 0 && exibirItemNovo">
                        <div class='d-flex'>
                            <ComboBoxWithDelete :only-numbers="true" ref="comboBoxWithDelete"
                                                style="max-width:330px;padding:0px;margin-top:-20px;margin-bottom: -20px;margin-right: 5px; margin-left: 5px;"
                                                :id="item.id" v-model="itemNovo.unidadesNegocioExclusivas"
                                                @data="$event => { setarItensListaDeUnidadeNegocioExclusiva($event) }"
                                                @datanew="$event => { setarItensListaDeUnidadeNegocioExclusiva($event) }"
                                                @delete="$event => { excluirItemListaDeUnidadeNegocioExclusiva($event) }">
                            </ComboBoxWithDelete>

                            <v-icon size="36" color="primary"
                                    @click="() => { desativarItemNovo() }">
                                mdi-trash-can-outline
                            </v-icon>
                        </div>
                    </td>
                </template>
            </DataTable>
            <v-layout class="justify-end">
                <v-btn v-if="exibirItemNovo" style="position:relative;z-index:1" id="ButtonSubmit"
                       class="col-md-2 offset-md-4 mt-4 " type="submit" color="primary">
                    SALVAR
                </v-btn>
            </v-layout>
        </m-form>
        <v-layout class="justify-end">
            <v-btn v-if="!exibirItemNovo" style="position:relative;z-index:1" id="ButtonNovo"
                   class="col-md-2 offset-md-4 mt-6" type="button" color="primary"
                   @click="() => { exibirItemNovoNaTela() }">
                NOVO
            </v-btn>
        </v-layout>
    </div>
</template>

<script>

  import ComboBoxWithDelete from '../../components/ComboBoxWithDelete.vue'
  import { alert, sleep, notification } from '@/plugins/helpers'
  import * as Qs from 'qs'

  export default {

    name: 'Ambientes',
    components: {
      ComboBoxWithDelete
    },
    data: () => ({
      exibirItemNovo: false,
      itemNovo: {
        id_visual: '',
        idVisualPadraoParaEmpresas: false,
        id_empresa_newcon: '',
        unidadesNegocioExclusivas: [],
        unidadeCondicoesVenda: ''
      },
      opacity_visual_padrao: 0,
      opacidade_unidade_exclusiva: 0,
      opacity_unidade_condicoes: 0,
      identidades_visuais: [],
      empresas_newcon: [],
      opacity_aviso_principal: 0,
      opacity_perfil: 0,
      dtFiltro: {},
      mensagens: {
        'confirmacao': `Tem certeza que deseja $1 o ambiente “$2”?'\n Esta ação não poderá ser desfeita.`,
        'sucesso': `Registro $1 com sucesso`,
        'erro': `Não foi possível $1 este registro, tente novamente em instantes.`
      },
      params: {
        pagination: {
          rowsPerPage: 12,
          page: 1,
          sortBy: 'id',
          descending: false
        },
        data_hora_de: null,
        data_hora_ate: null,
        funcionalidade: null,
        operacao: null
      },
      headers: [
        { text: 'ID', value: 'id', icon: 'mdi-help-box' },
        { text: 'ID Visual', value: 'id_visual', icon: 'mdi-help-box' },
        { text: 'ID Visual Padrão para empresa', value: 'id_visual_padrao_para_empresas', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Será disponibilizado para o usuário esta identidade visual quando o usuário tiver acesso a ao menos uma das empresas desta identidade visual e a unidade de negócio do usuário no Newcon não estiver definida como unidade de negócio exclusiva em nenhum ID visual.'], opacity: 0 },
        { text: 'Empresa', value: 'id_empresa_newcon', icon: 'mdi-help-box' },
        { text: 'Unidade para condições de venda', value: 'unidade_condicoes_venda', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Configuração relacionado à qual unidade de negócio o sistema irá requisitar os métodos do fluxo de vendas, essa configuração só é habilitada se o usuário tiver acesso à unidade configurada.'], opacity: 0 },
        { text: 'Unidade de negócio exclusiva', value: 'unidades_negocio_exclusivas', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Só estará disponível para o usuário as identidades visuais que contenham neste campo a unidade de negócio do usuário no Newcon. Se a unidade de negócio do usuário no Newcon não estiver definida como exclusiva para nenhuma identidade visual, será considerada a regra do campo'], opacity: 0 }
      ]
    }),
    mounted () {
      this.getIdentidadesVisuais()
      this.getEmpresasNewcon()
    },
    methods: {
      async enviar () {
        const form = this.$refs.form
        if (form.validate()) {
          await sleep(200)
          this.addAmbiente()
        } else {
          return false
        }
      },
      exibirItemNovoNaTela () {
        this.exibirItemNovo = true
        this.itemNovo = {
          id_visual: '',
          idVisualPadraoParaEmpresas: false,
          id_empresa_newcon: '',
          unidadesNegocioExclusivas: [],
          unidadeCondicoesVenda: ''
        }
      },
      desativarItemNovo () {
        this.exibirItemNovo = false
        this.itemNovo = {
          id_visual: '',
          idVisualPadraoParaEmpresas: false,
          id_empresa_newcon: '',
          unidadesNegocioExclusivas: []
        }
      },
      setarItensListaDeUnidadeNegocioExclusiva (itensNovos) {
        this.itemNovo.unidadesNegocioExclusivas = itensNovos
      },
      setarItensUnidadeCondicoesVenda (itensNovos) {
        this.itemNovo.unidadeCondicoesVenda = itensNovos
      },
      excluirItemListaDeUnidadeNegocioExclusiva (itemAExcluir) {
        this.itemNovo.unidadesNegocioExclusivas = this.itemNovo.unidadesNegocioExclusivas.filter(item => +item !== +itemAExcluir)
      },
      emitLoad () {
        this.$emit('load')
      },
      recarregarTabela () {
        this.exibirItemNovo = false
        this.$refs.data_table_ambientes.reload()
      },
      getIdentidadesVisuais () {
        this.$http.get('/painel/ambientes/identidades-visuais')
          .then(response => {
            this.identidades_visuais = response.data
          })
          .catch(error => {
            console.error(error)
          }).finally(() => {
            this.emitLoad()
          })
      },
      getEmpresasNewcon () {
        this.$http.get('/painel/ambientes/empresas-newcon')
          .then(response => {
            this.empresas_newcon = response.data
          })
          .catch(error => {
            console.error(error)
          }).finally(() => {
            this.emitLoad()
          })
      },
      retornaNomeEmpresa (id, nome) {
        return id + ' - ' + nome
      },
      retornaMensagemPadraoDaTelaAmbientes (idAmbiente, identidadeVisual, idEmpresaNewcon) {
        return `[${idAmbiente}] - ID Visual ${identidadeVisual} empresa ${idEmpresaNewcon} - ${this.empresas_newcon.find((empresa) => { return +empresa.id_empresa_newcon === +idEmpresaNewcon }).nm_empresa_newcon}`
      },
      dialogChangeUnidadeNegocio (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeExclusiva) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)
        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.addUnidadeExclusiva(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas, unidadeExclusiva)
          }
        })
      },
      dialogChangeIdentidadeVisual (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)
        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.changeIdentidadeVisual(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas)
          }
        })
      },
      dialogChangeIdVisualPadraoTodasEmpresas (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)
        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.changeIdVisualPadraoTodasEmpresas(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas)
          }
        })
      },
      dialogChangeEmpresaNewcon (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)
        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.changeEmpresaNewcon(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas)
          }
        })
      },
      dialogExcluirAmbiente (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'excluir').replace('$2', AmbienteCompleto)
        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => this.ExcluirAmbiente(idAmbiente, AmbienteCompleto, idVisualPadraoParaEmpresas)
          }
        })
      },
      dialogDeleteUnidadeExclusiva (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeExclusiva) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)

        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.deleteUnidadeExclusiva(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas, unidadeExclusiva)
          }
        })
      },
      dialogChangeUnidadeCondicoesVenda (idAmbiente, identidadeVisual, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeCondicoesVenda) {
        const AmbienteCompleto = this.retornaMensagemPadraoDaTelaAmbientes(idAmbiente, identidadeVisual, idEmpresaNewcon)
        const mensagem = this.mensagens.confirmacao.replace('$1', 'alterar').replace('$2', AmbienteCompleto)

        alert({
          text: mensagem,
          buttons: {
            'Cancelar': () => this.recarregarTabela(),
            'Confirmar': () => this.addUnidadeVenda(idAmbiente, identidadeVisual, idEmpresaNewcon, AmbienteCompleto, idVisualPadraoParaEmpresas, unidadeCondicoesVenda)
          }
        })
      },
      addUnidadeVenda (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas, unidadeCondicoesVenda) {
        this.$http.post('/painel/ambiente/add-unidade-venda', {
          idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeCondicoesVenda
        }).then(() => {
          notification('success', 'Unidade de condições de venda atualizada!')
          this.recarregarTabela()
        }).catch(() => {
          notification('error', 'Erro ao atualizar unidade de condições de venda!')
        })
      },
      changeIdentidadeVisual (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas) {
        this.$http.put('/painel/ambiente/id-visual', { idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas }).then((result) => {
          const mensagem = this.mensagens.sucesso.replace('$1', 'atualizado')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        }).catch(() => {
          const mensagem = this.mensagens.erro.replace('$1', 'atualizar')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        })
      },
      exportarExcel () {
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: {},
          pagination: { sortBy: 'id', descending: false },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/ambientes/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      changeIdVisualPadraoTodasEmpresas (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas) {
        this.$http.put('/painel/ambiente/id-visual-padrao', { idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas }).then((result) => {
          const mensagem = this.mensagens.sucesso.replace('$1', 'atualizado')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        }).catch(() => {
          const mensagem = this.mensagens.erro.replace('$1', 'atualizar')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        })
      },
      changeEmpresaNewcon (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas) {
        this.$http.put('/painel/ambiente/empresa-newcon', { idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas }).then((result) => {
          const mensagem = this.mensagens.sucesso.replace('$1', 'atualizado')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        }).catch(() => {
          const mensagem = this.mensagens.erro.replace('$1', 'atualizar')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        })
      },
      deleteUnidadeExclusiva (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas, unidadeNegocioExclusiva) {
        this.$http.post('/painel/ambiente/exclude-unidade-negocio', { idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeNegocioExclusiva }).then((result) => {
          const mensagem = this.mensagens.sucesso.replace('$1', 'atualizado')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        }).catch(() => {
          const mensagem = this.mensagens.erro.replace('$1', 'atualizar')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        })
      },
      addAmbiente () {
        sleep(100)
        this.$http.post('/painel/ambiente', {
          identidadeVisual: this.itemNovo.id_visual,
          idEmpresaNewcon:
            this.itemNovo.id_empresa_newcon,
          idVisualPadraoParaEmpresas:
            this.itemNovo.idVisualPadraoParaEmpresas,
          unidadeNegocioExclusiva:
            this.itemNovo.unidadesNegocioExclusivas,
          unidadeCondicoesVenda: this.itemNovo.unidadeCondicoesVenda
        })
          .then((result) => {
            const mensagemSucesso = this.mensagens.sucesso.replace('$1', 'inserido')
            notification('success', mensagemSucesso)
            this.recarregarTabela()
          })
          .catch((error) => {
            const mensagemErro = this.mensagens.erro.replace('$1', 'inserir')
            notification('error', error || mensagemErro)
          })
      },
      addUnidadeExclusiva (idAmbiente, identidadeVisual, idEmpresaNewcon, mensagemAuditoria, idVisualPadraoParaEmpresas, unidadeNegocioExclusiva) {
        this.$http.post('/painel/ambiente/add-unidade-negocio', { idAmbiente, identidadeVisual, mensagemAuditoria, idEmpresaNewcon, idVisualPadraoParaEmpresas, unidadeNegocioExclusiva }).then((result) => {
          const mensagem = this.mensagens.sucesso.replace('$1', 'atualizado')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        }).catch(() => {
          const mensagem = this.mensagens.erro.replace('$1', 'alterar')
          alert({
            text: mensagem,
            buttons: {
              'Ok': () => this.recarregarTabela()
            }
          })
        })
      },
      ExcluirAmbiente (idAmbiente, mensagemParaAuditoria, idVisualPadraoParaEmpresas) {
        idVisualPadraoParaEmpresas = idVisualPadraoParaEmpresas ? 'Sim' : 'Não'
        mensagemParaAuditoria = mensagemParaAuditoria + ` ID Visual Padrão = ${idVisualPadraoParaEmpresas}`

        this.$http.delete(`/painel/ambiente/${+idAmbiente}/${mensagemParaAuditoria}`)
          .then((result) => {
            const mensagemSucesso = this.mensagens.sucesso.replace('$1', 'removido')
            notification('success', mensagemSucesso)
            this.recarregarTabela()
          })
          .catch((error) => {
            const mensagemErro = this.mensagens.erro.replace('$1', 'excluir')
            notification('error', error || mensagemErro)
          })
      }

    }
  }

</script>

<style lang="scss" scoped>
.icon-container {
    display: inline-flex;
    align-items: center;
    width: 100%;
}

.icon-title {
    display: inline;
    position: absolute;
    width: 100vw;
    max-width: 60vw;
    left: 30px;
    top: 19px;
    color: var(--primary);
}

.container {
    width: 100%;
    height: 100%;
}

.tooltip-descricao-perfil {
    position: absolute;
    margin-top: 12px;
    left: 0;
    top: 100%;
    padding: 12px;
    max-width: 500px;
    width: 500px;
    background-color: #eee;
    color: #666;
    opacity: 0;
    transition: all ease 2s;
    z-index: -2;
}

.tooltip-descricao-visual_padrao {
    position: absolute;
    margin-top: 10px;
    right: 0;
    top: 100%;
    padding: 12px;
    background-color: #eee;
    color: #666;
    max-width: 300px;
    width: 400px;
    opacity: 0;
    z-index: 2;
}
</style>

<style lang="scss">
.apagaInput div div div:nth-child(2) {
    display: none;
}
</style>
